/** The backup worker started from its bundle under the app's Trusted Types policy (part 24e; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { BackupWorker } from './controller.ts';

/** T6, T7: a function starting a backup worker (a module worker) for each run. */
export function backupWorker(source: WorkerSource<BackupWorker>): (store: string) => BackupWorker {
  // Part 36a, table BK10: named by the book store it reads, which the worker opens by that name.
  return (store) => new source.Worker(source.trusted(source.url), { type: 'module', name: store });
}
